export default "__VITE_ASSET__B82Jf2Jx__"